<button
  type="button"
  class="ki-panel-overlay"
  tabindex="-1"
  [attr.aria-label]="'ki.panel.schliessen' | translate"
  (click)="geschlossen.emit()"
></button>
<div
  #panel
  class="ki-panel"
  role="dialog"
  aria-modal="true"
  tabindex="-1"
  data-testid="ki-panel"
  cdkTrapFocus
  [attr.aria-label]="titel()"
  (keydown.escape)="escape($event)"
>
  <div class="ki-panel__kopf">
    <app-ki-mark [size]="26" />
    <div class="ki-panel__ueberschrift">
      <div class="ki-panel__titel">{{ titel() }}</div>
      @if (kontext()) {
        <div class="ki-panel__untertitel">{{ kontext() }}</div>
      }
    </div>
    <button
      type="button"
      class="ki-panel__schliessen"
      data-testid="ki-panel-schliessen"
      [attr.aria-label]="'ki.panel.schliessen' | translate"
      (click)="geschlossen.emit()"
    >
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
  </div>
  <div class="ki-panel__inhalt">
    <ng-content />
  </div>
  <div class="ki-panel__fuss">
    <ng-content select="[kiPanelFuss]" />
  </div>
</div>
